import toastr from 'toastr'

import Http from '@shared/http'
import { parseNumber } from '@utils/numberConversions'
import { redirect } from 'react-router-dom'

export const submitImportableAssets = (state) => {
  const {
    selectedAssets,
    paths: { importAssetsPath },
  } = state

  toastr.options.positionClass = 'toast-footer-small'

  let params = {
    assets: selectedAssets.map((a) => buildAsset(a)),
  }

  return makeImportAssetsRequest(importAssetsPath, params)
}

const makeImportAssetsRequest = (importAssetsPath, params) => {
  return new Promise((res, rej) => {
    Http.request(
      importAssetsPath,
      'POST',
      JSON.stringify(params),
      'follow',
    ).then(
      (response) => {
        if (response.ok) {
          window.location.href = response.url;
        } else {
          handleErrorResponse(rej)
        }
      },
      () => handleErrorResponse(rej)
    )
  })
}

const handleErrorResponse = (rejFn) => {
  toastr.warning(
    'Something went wrong while importing the selected assets. Please try again.'
  )
  rejFn(false)
}

const buildAsset = (asset) => {
  const date = new Date()
  return {
    asset_type: asset.asset_type,
    name: buildAssetName(asset),
    created_at: date,
    updated_at: date,
    price_date: asset.price_date,
    currency: asset.currency ? asset.currency.toLowerCase() : 'zar',
    contract_number: asset.contract_number,
    gross_value: parseNumber(asset.gross_value) || 0,
    monthly_contribution: parseNumber(asset.monthly_contribution) || 0,
    service_provider_name: asset.provider_name,
    owners: asset.owners || [],
    payers: asset.payers || [],
    beneficiaries: asset.beneficiaries || [],
  }
}

const buildAssetName = (asset) => {
  return `${asset.provider_name} - ${asset.name}`
}
